import { IBetHistoryApi } from '../api/betHistoryApi'
import { BetHistoryRequest } from '../api/BetHistoryRequest'
import { useBetHistoryStore } from '../store/betHistoryStore'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export class BetHistoryService {
  private _api: IBetHistoryApi

  constructor(api: IBetHistoryApi) {
    this._api = api
  }

  async getBetList() {
    const startTime = dayjs.utc().add(-7, 'days')
    const endTime = dayjs.utc()

    useBetHistoryStore.setState({
      isLoading: true,
      startTime: startTime.format('YYYY/MM/DD  HH:mm'),
      endTime: endTime.format('YYYY/MM/DD  HH:mm'),
    })

    const request: BetHistoryRequest = {
      startTime: startTime.format(),
      endTime: endTime.format(),
      pageSize: 200,
      currentPage: 0,
    }

    const response = await this._api.getBetHistory(request)
    response.betList.forEach((bet) => {
      bet.orderTime = dayjs.utc(bet.orderTime).format('YYYY/MM/DD  HH:mm')
    })

    useBetHistoryStore.setState({
      ...response,
      isLoading: false,
    })
  }
}
